import React, { useState, useEffect } from "react";
import Header from "../../../components/header/Header";
import Footer from "../../../components/footer/Footer";
import { useNavigate, useLocation, useParams } from "react-router-dom";
import {
  findPrescriptionListFromChimeConversation,
  patientInformation,
  prescription,
  getProfile,
  createPrescChatCompletionForStarpilot,
  findPastoralSummaryFromChime,
} from "../../../api/apiHandler";
import Swal from "sweetalert2";
import queryString from "query-string";
import moment from "moment";
// import PatientInfoPop from "./PatientInfoPop/index.jsx";
import PatientInfoPop from "../prescription/DoctorInfoPop/index.jsx";
import DoctorInfoPop from "./DoctorInfoPop/index.jsx";
import QRCodePop from "./QrCodePop/index.jsx";
import styled from "styled-components";
import { EmailPrescriptionPopup } from "../../../modal/emailPrescriptionPopup";
import PriestMeetingRecord from "../meeting-record/PriestMeetingRecord.js";
import PatientInfoEditPop from "../prescription/PatientInfoEditPop/index.jsx";
import NotesModal from "./Notes/PrescriptionNotes.js";
import { TbInfoTriangle } from "react-icons/tb";

function AutoPrescription() {
  const navigate = useNavigate();
  const location = useLocation();
  console.log("location.state: ", location.state);
  const params = queryString.parse(window.location.search);
  console.log("params12345e", params);
  const [doctorDataDetails, setDoctorDataDetails] = useState(null);
  const [qrCodeUrl, setQrCodeUrl] = useState("");
  const [doctorInfo, setDoctorInfo] = useState();
  const [meetingData, setMeetingData] = useState(params);
  const [typepres, settypepres] = useState();
  console.log("meetingData", meetingData);
  const [medicineList, setMedicineList] = useState();
  console.log("medicineList1234", medicineList);
  const [patientId, setPatientId] = useState(meetingData.patient_id);
  console.log("patientIdsa332", meetingData);

  const [patientData, setPatientData] = useState(null);
  const [isOpen, setIsOpen] = useState(false);
  const userRole = localStorage.getItem("user_login_type_role");
  useEffect(() => {
    const fetchData = async () => {
      if (meetingData != null) {
        Swal.fire({
          title: "Please wait...",
          didOpen: () => {
            Swal.showLoading();
          },
        });

        const findPrescriptionObj = {
          meeting_id: meetingData.meeting_id,
        };

        let response;

        try {
          if (params.from === "singleUser") {
            response = await createPrescChatCompletionForStarpilot({
              uuid: meetingData.meeting_id,
              login_type_role: userRole,
            });
            getDoctorDetails();
          } else if (userRole == "4") {
            response = await findPastoralSummaryFromChime(findPrescriptionObj);
            getPatientDetails();
            getDoctorDetails();
          } else {
            response = await findPrescriptionListFromChimeConversation(
              findPrescriptionObj
            );
            getPatientDetails();
            getDoctorDetails();
          }

          response = JSON.parse(response);

          console.log("Autoprescription12response", response);
          if (response.code === 200) {
            setMedicineList(response.data.response);
            setQrCodeUrl(response.data.qrCode);
            setPatientId(response.data.patient_id);
            Swal.close();
          } else {
            Swal.fire({
              position: "top-end",
              icon: "error",
              title: response.message,
              toast: true,
              showConfirmButton: false,
              timer: 2000,
            });
          }
        } catch (error) {
          console.error("Error fetching prescription:", error);
          Swal.fire({
            position: "top-end",
            icon: "error",
            title: "Something went wrong!",
            toast: true,
            showConfirmButton: false,
            timer: 2000,
          });
        }
      }
    };

    fetchData();
  }, []);

  const getPatientDetails = () => {
    if (patientId != 0) {
      patientInformation({ patient_id: patientId }).then((response) => {
        response = JSON.parse(response);
        console.log("respons23333de43e", response);
        if (response.code == process.env.REACT_APP_SUCCESS) {
          setPatientData(response.data);
        } else {
          setPatientData(null);
          Swal.fire({
            position: "top-end",
            icon: "error",
            title: response.message,
            toast: true,
            showConfirmButton: false,
            timer: 2000,
          });
        }
      });
    }
  };

  const getDoctorDetails = () => {
    getProfile({}).then((response) => {
      response = JSON.parse(response);
      console.log("responsdoctri333e", response);
      if (response.code == process.env.REACT_APP_SUCCESS) {
        setDoctorDataDetails(response.data);
      }
      // Swal.close()
    });
  };

  console.log(meetingData, "meetingDatawwssxdww2123344");

  const handleSendRx = () => {
    Swal.fire({
      title: "Please wait...",
      didOpen: () => {
        Swal.showLoading();
      },
    });
    var params = {
      patient_id: patientId,
      meeting_id: meetingData.meeting_id,
      appointment_id: meetingData.appointment_id,
      prescription_date: moment().utc().format("YYYY-MM-DD"),
      first_name: patientData != null ? patientData.first_name : null,
      last_name: patientData != null ? patientData.last_name : null,
      age: patientData != null ? patientData.age : 0,
      date_of_birth: null,
      gender: null,
      county: patientData != null ? patientData.country : null,
      state: patientData != null ? patientData.state : null,
      city: patientData != null ? patientData.city : null,
      address: patientData != null ? patientData.address : null,
      zipcode: null,
      physician_first_name: null,
      physician_last_name: null,
      additional_direction: null,
      permission_code: null,
    };
    console.log("paramssssssss333", params);
    prescription(params).then((response) => {
      response = JSON.parse(response);
      console.log("response", response);
      if (response.code == process.env.REACT_APP_SUCCESS) {
        const sendRxObj = {
          prescription_id: response.data.id,
          patient_id: patientId,
          appointment_id: meetingData.appointment_id,
        };
        console.log("sendRxObj", sendRxObj);
        navigate("/doctor/chemist-list", { state: sendRxObj });
      } else {
        Swal.fire({
          position: "top-end",
          icon: "error",
          title: response.message,
          toast: true,
          showConfirmButton: false,
          timer: 2000,
        });
      }
      Swal.close();
    });
  };

  const [patiendInfo, setPatientInfo] = useState();
  const [patiendInfoEdit, setPatientInfoEdit] = useState();
  const [qrCode, setQrCode] = useState();
  const handlePatientInfo = (type) => {
    setPatientInfo(!patiendInfo);
    settypepres(type);
  };
  const handleDoctorInfo = (type) => {
    setDoctorInfo(!doctorInfo);
    settypepres(type);
  };
  const handleQRCode = (type) => {
    setQrCode(!qrCode);
    settypepres(type);
  };
  const isOpenMailModal = (prescription) => {
    const userRole = localStorage.getItem("user_login_type_role");

    if (!userRole) {
      navigate("/");
      return;
    }

    setIsOpen(true);
  };
  const [openNotes, setOpenNotes] = useState(false);

  const handleViewNotes = () => {
    setOpenNotes(true);
  };
  return (
    <>
      <EmailPrescriptionPopup
        isOpen={isOpen}
        setIsOpen={setIsOpen}
        medicineList={medicineList}
        doctorData={doctorDataDetails}
        patientData={patientData}
      />

      <PatientInfoPop
        patientData={patientData}
        patiendInfo={patiendInfo}
        setPatientInfo={setPatientInfo}
        mainPrescription={medicineList}
        typepres={typepres}
      />

      <PatientInfoEditPop
        patiendInfo={doctorInfo}
        setPatientInfo={setDoctorInfo}
        // setPatientInfoData={setPatientInfoData}
        patientinfoData={doctorDataDetails}
        mainPrescription={medicineList}
        typepres={typepres}
      />

      <QRCodePop
        datePresc={moment().utc().format("D MMMM YYYY")}
        qrCodeUrl={qrCodeUrl}
        docData={doctorDataDetails}
        patientData={
          params.from === "singleUser" ? doctorDataDetails : patientData
        }
        medicineList={medicineList}
        qrCode={qrCode}
        setQrCode={setQrCode}
        mainPrescription={medicineList}
        typepres={typepres}
      />
      <NotesModal show={openNotes} onClose={setOpenNotes} note={medicineList} />
      <main className="bg-color flex-column">
        <Header />
        <section className="doctorsec-pad share-medical">
          <div className="container">
            <div className="card">
              <div className="card-body doctor-table-card">
                {userRole == "4" ? (
                  <PriestMeetingRecord
                    medicineList={medicineList}
                    handleQRCode={handleQRCode}
                    handlePatientEditInfo={handleDoctorInfo}
                    isOpenMailModal={isOpenMailModal}
                    handlePatientInfo={handlePatientInfo}
                    meetingData={meetingData}
                    type={
                      meetingData?.prescriptionType == "tempPres"
                        ? "tempPres"
                        : "final_pres"
                    }
                    settypepres={settypepres}
                  />
                ) : (
                  <>
                    <div className="d-flex justify-content-between align-center mb-2">
                      <div
                        className="content text-black "
                        style={{ fontFamily: "Aharoni" }}
                      >
                        <h2
                          className="m-0 fw-bold text-center"
                          style={{
                            color: "#216fc8",
                          }}
                        >
                          {userRole == "4"
                            ? meetingData?.prescriptionType == "tempPres"
                              ? "Draft Pastoral Report"
                              : "Pastoral Report"
                            : meetingData?.prescriptionType == "tempPres"
                            ? "Temporary Prescription"
                            : "Final Prescription "}
                        </h2>
                      </div>
                      <button
                        className="px-3 py-2 rounded d-inline-flex align-items-center gap-2 bg-red-50 border border-red-200 shadow-sm hover:bg-red-100 transition-all"
                        onClick={handleViewNotes}
                        style={{ maxWidth: "max-content" }}
                      >
                        <TbInfoTriangle className="text-danger" size={20} />
                        <span className="fw-semibold text-red-700">Notes</span>
                      </button>
                    </div>
                    <div className="table-responsive">
                      <table className="doctor-list-table table table-bordered">
                        <thead>
                          <tr>
                            <th scope="row">Page</th>
                            <th>Name of Drug</th>
                            <th>Strength</th>
                            <th>Strength Type</th>
                            <th>Unit</th>
                            <th>Form</th>
                            <th>Dose</th>
                            <th>Frequency</th>
                            <th>Intakes or Applications</th>
                            <th>Route</th>
                            <th>Refills</th>
                            <th>Quantity</th>
                            <th>Comments</th>
                          </tr>
                        </thead>
                        <tbody>
                          {medicineList &&
                            medicineList.map((item, index) => {
                              return (
                                <tr id={item.id} key={index}>
                                  <td scope="row">{index + 1}</td>
                                  <td>
                                    <h3 className="doc-details">
                                      {item.medicine_name}
                                    </h3>
                                  </td>

                                  <td>{item.strength}</td>
                                  <td>{item.strength_type}</td>
                                  <td>{item.units || item.unit}</td>
                                  <td>{item.form || item.medicine_type}</td>
                                  <td>{item.dose}</td>
                                  <td>{item.frequency}</td>
                                  <td>
                                    {item.intakes_applications || item.intake}
                                  </td>
                                  <td>{item.route}</td>
                                  <td>{item.refills}</td>
                                  <td>{item.quantity}</td>
                                  <td>{item.comments}</td>
                                </tr>
                              );
                            })}
                        </tbody>
                      </table>
                    </div>
                    <PocPrescriptionWrpper className="d-flex mt-3 align-items-center justify-content-between flex-wrap gap-10">
                      <button
                        onClick={() => handleQRCode("prescription")}
                        className="submit-btn d-inline-flex justify-content-center"
                        style={{ maxWidth: "max-content" }}
                      >
                        QR Codes
                      </button>
                      <button
                        disabled={params?.from === "singleUser"}
                        className={`submit-btn d-inline-flex justify-content-center ${
                          params?.from === "singleUser" && "disabled"
                        }`}
                        style={{ maxWidth: "max-content" }}
                        onClick={handleSendRx}
                      >
                        Send Rx
                      </button>
                      <button
                        disabled={params?.from === "singleUser"}
                        className={`submit-btn d-inline-flex justify-content-center ${
                          params?.from === "singleUser" && "disabled"
                        }`}
                        style={{ maxWidth: "max-content" }}
                        onClick={handleSendRx}
                      >
                        Auto Rx
                      </button>

                      <button
                        onClick={isOpenMailModal}
                        className={
                          medicineList?.length === 0
                            ? "submit-btn d-inline-flex justify-content-center disabled"
                            : "submit-btn d-inline-flex justify-content-center"
                        }
                        style={{
                          maxWidth: "max-content",
                        }}
                        disabled={medicineList?.length === 0}
                      >
                        Mail Prescriptions
                      </button>
                      <button
                        onClick={() => handlePatientInfo("prescription")}
                        disabled={params?.from === "singleUser"}
                        className={`submit-btn d-inline-flex justify-content-center ${
                          params?.from === "singleUser" && "disabled"
                        }`}
                        style={{ maxWidth: "max-content" }}
                      >
                        Patient Info
                      </button>

                      <button
                        onClick={() => handleDoctorInfo("prescription")}
                        disabled={params?.from === "singleUser"}
                        className={`submit-btn d-inline-flex justify-content-center ${
                          params?.from === "singleUser" && "disabled"
                        }`}
                        style={{ maxWidth: "max-content" }}
                      >
                        {userRole == "4" ? "Clergy Info" : "Doctor Info"}
                      </button>
                    </PocPrescriptionWrpper>
                  </>
                )}
              </div>
            </div>
          </div>
        </section>
        <Footer />
      </main>
    </>
  );
}

const PocPrescriptionWrpper = styled.div`
  @media (max-width: 480px) {
    max-width: 300px;
    margin-left: auto;
    margin-right: auto;
    button {
      width: 100%;
      max-width: 100% !important;
    }
  }
`;

export default AutoPrescription;
